module.exports = __webpack_public_path__ + "img/宁心.44b80390.jpg";